import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {PartnersActions} from '../store';
import {PartnersSelectors} from '../store/selectors';

@Injectable()
export class PartnersLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.readPartnersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readPartnersDone(): Observable<boolean> {

    return this.store$.pipe(
      select(PartnersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc',
            isPartner: true
          };
          this.store$.dispatch(PartnersActions.ReadPartners({page: -1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
